// import { ChildrenStoreData } from "@parent-app/types";
import { ChildrenStoreData } from "src/shared/types/src";
import { getAxiosInstance } from "../api";
import { activitiesData } from "../mock";

export const fetchObservationDetails = async ({ child, observationId }: { child: ChildrenStoreData, observationId: string }): Promise<any> => {
    console.log("fetching reaction list for :", child.childId, observationId);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;
    return retryAxios.get(`/child/${child.childId}/observation/${observationId}`).then((res) => {
        console.log("response from get observation  call : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const fetchObservationFrameworks = async ({ child, observationId }: { child: ChildrenStoreData, observationId: string }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    return retryAxios.get(`/child/${child.childId}/observation/${observationId}/frameworks`).then((res) => {
        console.log("response from get frameworks  call : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const fetchObservationReactionsList = async ({ child, observationId }: { child: ChildrenStoreData, observationId: string }): Promise<any> => {
    console.log("fetching reaction list for :", child.childId, observationId);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;
    return retryAxios.get(`/child/${child.childId}/observation/${observationId}/likes`).then((res) => {
        console.log("response from get likes on observation  call : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const patchLikeOnObservation = async ({ child, observationId }: { child: ChildrenStoreData, observationId: string }): Promise<any> => {
    console.log("patching like on observation for :", child.childId, observationId);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;
    return retryAxios.patch(`/child/${child.childId}/observation/${observationId}/like`).then((res) => {
        console.log("response from patch like on observation  call : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const fetchObservationCommentsList = async ({ child, observationId }: { child: ChildrenStoreData, observationId: string }): Promise<any> => {
    console.log("fetching comments list for :", child.childId, observationId);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;
    return retryAxios.get(`/child/${child.childId}/observation/${observationId}/comments`).then((res) => {
        console.log("response from get comments on observation  call : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const addCommentOnObservation = async ({ child, observationId, commentText }: { child: ChildrenStoreData, observationId: string, commentText: string }): Promise<any> => {
    console.log("adding a comment on observation for :", child.childId, observationId);
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;
    return retryAxios.patch(`/child/${child.childId}/observation/${observationId}/add-comment`, { comment: commentText }).then((res) => {
        console.log("response from add comment on observation  call : ", res, res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const fetchLastObservationDetails = async ({ child }: { child: ChildrenStoreData }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `${child.instanceToken}`;
    return retryAxios.get(`/home/child/${child.childId}/last-observation`).then((res) => {
        // console.log("response from get last observation call : ", res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const deleteObservationCommentsList = async ({ child, observationId, commentId }: { child: ChildrenStoreData, observationId: string, commentId: string }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `Bearer ${child.instanceToken}`;
    return retryAxios.delete(`/child/${child.childId}/observation/${observationId}/comment/${commentId}`).then((res) => {
        console.log("response from delete comments on observation call : ", res.data);
        const response = res.data;
        if (response && response.status === "success") {
            return response.data;
        }
        return null;
    });
}

export const addObservationAPI = async ({ child, params }: { child: ChildrenStoreData, params: { timestamp: string, description: string, attachments?: string[] } }): Promise<any> => {
    const { retryAxios } = getAxiosInstance();
    // retryAxios.defaults.headers.common['Authorization'] = `Bearer ${child.instanceToken}`;

    return retryAxios.post(`/child/${child.childId}/observation`, params).then((res) => {
        const response = res.data;
        if (response && response.status === "success") {
            return response?.data;
        }
        return null;
    });
}; 